import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConfigColumn} from './configColumn.model';
import { ConfigValue} from './configValue.model';

export interface SubAssemblyDelta {
  ButtonName?: { button_name: string }[];
  SubFreeFormConfig: ConfigValue[];
  SubFreeFormValue: ConfigColumn[];
}

export interface DeltaManagerResponse {
  Body: {
    RecordCount: number;
  };
}

export interface DeltaButtonPayload {
  plant_name: string;
  button_name: string;
}

@Injectable({
  providedIn: 'root'
})

export class DeltaService {
  readonly rootURL = environment.apiGwUrl+"/Objects";
  readonly displayOrderManager = environment.apiGwUrl + "/displayorderManager";
  readonly valueManagerURL=environment.apiGwUrl+"/subAssemblyValueManager";
  readonly columnManagerURL=environment.apiGwUrl+"/subAssemblyColumnManager";
  readonly updateButtonNameUrl=environment.apiGwUrl+"/subAssemblyButtonManager";
  selectedColumnConfig:ConfigColumn | undefined;
  selectedValueConfig:ConfigValue | undefined;
  subAssemblyColumnData:any=[];
  lastActivatedTab:number;

  constructor(private http: HttpClient) { }

  getSubAssemblyDelta(plant: string) {
    return this.http.get<SubAssemblyDelta[]>(this.rootURL + "?type=subAssemblyDeltaList&plantName=" + plant + "&lineId=");
  }

  setSelectedColumnConfig(colcnfg: ConfigColumn) {
    this.selectedColumnConfig=colcnfg;
  }

  setSelectedValueConfig(valcnfg: ConfigValue) {
    this.selectedValueConfig=valcnfg;
  }

  createUpdateValueConfig(formData: ConfigValue){
    return this.http.post(this.valueManagerURL, formData);
  }


  deleteValueConfig(formData: ConfigValue & { type?: string }) {
    return this.http.post<DeltaManagerResponse>(this.valueManagerURL, formData);
  }

  createUpdateColumnConfig(formData: ConfigColumn){
    return this.http.post(this.columnManagerURL , formData);
  }


  deleteColumnConfig(formData: ConfigColumn & { type?: string }) {
    return this.http.post<DeltaManagerResponse>(this.columnManagerURL , formData);
  }

  storeSubAssemblyColumnData(arr){
    this.subAssemblyColumnData=arr;
  }

  storeActiveTab(tabIndex){
    this.lastActivatedTab=tabIndex;
  }

  updateDeltaButtonName(data: DeltaButtonPayload) {
    return this.http.post<DeltaManagerResponse>(this.updateButtonNameUrl, data);
  }

  
}
